import {IContextRawData} from 'modules/context/context-types';
import {performRequest, showMessage} from 'shared/utils';

export const getValidationResult = async (
    url: string,
    fieldKey: string,
    context?: IContextRawData,
): Promise<{id: number; codeCp: string}[]> => {
    try {
        const r = await performRequest({
            url,
            params: {
                organizationId: context?.organizationId,
                taxPeriodId: context?.taxPeriodId,
                fieldKey
            }});
        return r.data;
    } catch (e) {
        showMessage({isError: true, message: e.message || 'Проблемы с валидацией'});
        throw new Error(e);
    }
};